import { render, staticRenderFns } from "./ModalRead.vue?vue&type=template&id=00143d9c"
import script from "./ModalRead.vue?vue&type=script&lang=js"
export * from "./ModalRead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports